import React from "react";
import type ContentDashboardWidgetDto from "../../types/dtos/content-dashboard/ContentDashboardWidgetDto";
import DataPointScoreEmployeeWidgetCard from "./widgets/DataPointScoreEmployeeWidgetCard";
import LinkLibraryWidgetCard from "./widgets/LinkLibraryWidgetCard";
import ImageBannerWidgetCard from "./widgets/ImageBannerWidgetCard";

interface ContentDashboardWidgetCardProps {
  widget: ContentDashboardWidgetDto;
  fullWidth?: boolean;
}

/**
 * Router component that renders the appropriate widget card based on widget type.
 * This follows the discriminated union pattern to ensure type-safe rendering.
 */
const ContentDashboardWidgetCard: React.FC<ContentDashboardWidgetCardProps> = ({
  widget,
  fullWidth = false,
}) => {
  switch (widget.type) {
    case "DATA-POINT-SCORE_EMPLOYEE":
      return <DataPointScoreEmployeeWidgetCard widget={widget} />;
    case "LINK-LIBRARY":
      return <LinkLibraryWidgetCard widget={widget} />;
    case "IMAGE-BANNER":
      return <ImageBannerWidgetCard widget={widget} fullWidth={fullWidth} />;
  }
};

export default ContentDashboardWidgetCard;
